import { render, staticRenderFns } from "./UserDetailsPage.vue?vue&type=template&id=00232bad&scoped=true&"
import script from "./UserDetailsPage.vue?vue&type=script&lang=js&"
export * from "./UserDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00232bad",
  null
  
)

export default component.exports